import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {withStyles} from 'material-ui/styles/index'
import Grid from '../../common/components/Grid'
import Chip from 'material-ui/Chip'
import Avatar from 'material-ui/Avatar'
import SubdirectoryArrowRightIcon from 'material-ui-icons/SubdirectoryArrowRight'

const styles = theme => ({
  wrapper: {
    display: 'flex',
  },
  firstCategoryList: {
    width: '100%!important',
  },
  categoryList: {
    width: 'calc(100% - 39px)',
    overflowX: 'hidden',
    margin: 0,
    '&:hover, &:active': {
      overflowX: 'auto',
    },
  },
  chip: {
    cursor: 'pointer',
    webkitTapHighlightColor: 'rgba(0,0,0,0)',
    color: '#fff',
    backgroundColor: theme.palette.primary.main + '!important',
    '&:hover': {
      backgroundColor: theme.palette.primary.light + '!important',
    },
  },
  chipSelected: {
    backgroundColor: theme.palette.primary.light + '!important',
  },
  avatar: {
    backgroundColor: theme.palette.primary.dark,
    color: '#fff',
  },
  arrow: {
    margin: '5px 0 0 15px',
    color: '#575757',
  },
})

const CategoryList = ({classes, categories, search, selectCategory, deselectCategory}) => (
  <div>
    {categories.map((list, key) => (
      <div className={classes.wrapper} key={key}>
        {key > 0 ? <SubdirectoryArrowRightIcon className={classes.arrow}/> : null}
        <Grid
          container
          spacing={8}
          wrap="nowrap"
          className={classNames(classes.categoryList, {[classes.firstCategoryList]: key === 0})}
        >
          {list.toArray().map(category => (
            <Grid item key={category.get('ID')}>
              <Chip
                className={classNames({[classes.chipSelected]: category.get('Selected') === true})}
                classes={{clickable: classes.chip,}}
                avatar={
                  <Avatar className={classes.avatar}>
                    {category.get('Description').substr(0, 1).toUpperCase()}
                  </Avatar>
                }
                onDelete={
                  category.get('Selected') === false
                    ? null
                    : () => {
                      deselectCategory(category.get('ID'))
                      search()
                    }
                }
                label={category.get('Description')}
                onClick={() => {
                  category.get('Selected') === true
                    ? deselectCategory(category.get('ID'))
                    : selectCategory(category.get('ID'), category.get('IsLeaf'))
                  search()
                }}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    ))}
  </div>
)

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectCategory: PropTypes.func.isRequired,
  deselectCategory: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
}

export default withStyles(styles, {withTheme: true})(CategoryList)



// WEBPACK FOOTER //
// ./src/common/components/CategoryList.js